import React, { useRef } from "react";
import { Heart } from "lucide-react";
import {
  WorkflowModalBody,
  WorkflowModalFooter,
  WorkflowModalHeader,
  WorkflowModalShell,
} from "./workflow/WorkflowModal";
import { ReadableNavButton } from "./Sticker";

export default function FavouriteSeriesPromptDialog({
  open,
  eventName,
  busy = false,
  onStar,
  onDismiss,
}) {
  const dialogRef = useRef(null);
  if (!open) return null;

  return (
    <WorkflowModalShell
      dialogRef={dialogRef}
      onClose={onDismiss}
      testId="favourite-series-prompt-dialog"
      titleId="favourite-series-prompt-title"
      maxWidthClass="sm:max-w-[480px]"
    >
      <WorkflowModalHeader
        eyebrow={<Heart className="w-4 h-4" strokeWidth={2.5} aria-hidden />}
        title="Follow this series?"
        titleId="favourite-series-prompt-title"
        onClose={onDismiss}
        closeTestId="favourite-series-prompt-close"
      />
      <WorkflowModalBody>
        <p className="font-ui font-medium text-[15px] text-ink/80 leading-relaxed">
          You&apos;ve been to {eventName || "this event"} a few times. Follow it to get schedule updates and
          day-of RSVP reminders in Notifications.
        </p>
      </WorkflowModalBody>
      <WorkflowModalFooter className="flex flex-col sm:flex-row gap-2">
        <ReadableNavButton
          type="button"
          variant="primary"
          onClick={onStar}
          disabled={busy}
          className="w-full sm:flex-1"
          data-testid="favourite-series-prompt-star"
        >
          Follow
        </ReadableNavButton>
        <ReadableNavButton
          type="button"
          onClick={onDismiss}
          disabled={busy}
          className="w-full sm:flex-1"
          data-testid="favourite-series-prompt-later"
        >
          Not now
        </ReadableNavButton>
      </WorkflowModalFooter>
    </WorkflowModalShell>
  );
}
